import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { createAbbreviation } from "../../../utils/Helper";
import { DateTime } from "luxon";
import { useCommon } from "../../Common/useCommon";

export const useProjectAddOrEdit = ({ selectProjectId, getProjectHighlights }) => {

    const [option, setOptions] = useState([]);
    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [rows, setRows] = useState([{ user: "", issueType: "" }]);
    const [projectData, setProjectData] = useState({
        project_user_roles: [],
        project_start_date: new Date(),
        project_name: '',
        is_billable: null,
        is_auto_build_allow: false,
        is_import_allow: false
    })
    const [statefill, setStatefill] = useState(false);
    const [editProject, setEditProject] = useState(false);
    const [previousData, setPreviousData] = useState({});
    const [previousRows, setPreviousRows] = useState([{ user: "", issueType: "" }]);
    const [confirmation, setConfirmation] = useState({});
    const [mismatchedUsers, setMismatchedUsers] = useState([])
    const [showPopup, setShowPopup] = useState(false);
    const { checkPermission } = useCommon();
    const tagRef = useRef();


    useEffect(() => {
        callautopopulate("project_leads", "all_users", "project_types", "project_role", "projects", "client", "issue_type", "project_status", "product", "project_role_category").then(res => {
            const userOption = res?.all_users
                ?.map((user) => ({
                    name: user.user_display_name,
                    user_code: user.user_code,
                    product_accountId: user.product_accountId,
                    is_billable: user.is_billable
                }))
                .sort((a, b) => a.name?.localeCompare(b.name));
            setOptions({
                userOption: userOption,
                leadOption: res.project_leads,
                projectRoleOption: res?.project_role.sort((a, b) => a.project_role_name?.localeCompare(b.project_role_name)),
                projectTypeOption: res?.project_types,
                projectsOption: res?.projects?.sort((a, b) => a.project_name.localeCompare(b.project_name)),
                clientOption: _.uniq(_.sortBy(res?.client, "client_name"), "client_id"),
                issueTypeOption: _.sortBy(_.map(res?.issue_type, item => ({
                    issue_type_name: item.issue_type_name, issue_type_id: item.issue_type_id,
                    // product_code: item?.product_code
                })), "issue_type_name"),
                projectStatus: res?.project_status,
                productOption: res?.product,
                category: _.sortBy(res?.project_role_category, "category_name").map(item => { return { ...item, label: item?.category_name } }),

            })
            res?.product?.forEach((val) => {
                if (val?.is_default) {
                    setProjectData((prev) => ({ ...prev, product_code: val }))
                    return
                }
            })
            setStatefill(true)
        });

    }, [])

    useEffect(() => {
        selectProjectId?.project_id && statefill && getProjectDetails(selectProjectId?.project_id, selectProjectId?.product_code);
    }, [selectProjectId?.project_id, statefill])

    // handle project data after enter new 
    useEffect(() => {
        if (projectData?.project_id === 0) {
            setProjectData((prev) => ({
                ...prev,
                project_user_roles: [],
                project_start_date: new Date(),
                project_end_date: null,
                client_id: [],
                project_status_id: {},
                project_type_id: {},
                project_lead_user_code: {},
                projectRole: {},
                user: [],
                is_auto_build_allow: false
            }))
            setRows([{ user: "", issueType: "" }]);
            setPreviousRows(JSON.parse(JSON.stringify([{ user: "", issueType: "" }])));
        } else {
            projectData?.project_id !== undefined && getProjectUserList(projectData?.project_id, projectData?.project_name?.product_code)
        }
    }, [projectData?.project_id])

    // this function fetch the project details  
    const getProjectDetails = async (id, productCode) => {
        try {
            const payload = {
                "project_id": id,
                "product_code": productCode ? productCode : projectData?.product_code?.product_code,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTDETAILS"), payload);
            if (res?.body?.error_status === false) {
                const projectDetails = res?.body?.data?.project_details?.[0]
                // Function to update project data
                const users = _.sortBy(_.filter(res?.body?.data?.project_users, item => item.user_code !== null), "user_display_name").map(item => ({
                    ...item, communicators_category_ids: item?.communicators_category_ids?.split(",")?.map(id => Number(id.trim())), is_remove: false
                }))
                const updateProjectData = (prev, projectDetails) => ({
                    ...prev,
                    product_code: _.find(option?.productOption, (item) => item.product_code === projectDetails?.product_code),
                    product_project_id: projectDetails?.product_project_id,
                    project_name: _.find(option?.projectsOption, (item) => item.project_id === projectDetails?.project_id && item.product_code === projectDetails?.product_code),
                    project_lead_user_code: _.find(option?.leadOption, (item) => item.user_code === projectDetails?.project_lead_user_code),
                    client_id: _.filter(option?.clientOption, (item) => projectDetails?.client_ids?.includes(item?.client_id)),
                    project_status_id: _.find(option?.projectStatus, (item) => item?.project_status_id === projectDetails?.project_status_id),
                    project_type_id: _.find(option?.projectTypeOption, (item) => item?.project_type_id === projectDetails?.project_type_id),
                    project_id: projectDetails?.project_id,
                    project_key: projectDetails?.project_key,
                    is_project_lead: projectDetails?.is_project_lead,
                    project_start_date: projectDetails?.project_start_date ? new Date(projectDetails?.project_start_date) : "",
                    project_end_date: projectDetails?.project_end_date ? new Date(projectDetails?.project_end_date) : "",
                    project_user_roles: users,
                    is_auto_build_allow: projectDetails?.is_auto_build_allow || false,
                    is_import_allow: projectDetails?.is_import_allow || false
                });
                setProjectData((prev) => updateProjectData(prev, projectDetails, option));
                setPreviousData((prev) => updateProjectData(prev, projectDetails, option));
                if (res?.body?.data?.issue_type_details.length > 0) {
                    const groupedData = res?.body?.data?.issue_type_details.reduce((acc, item) => {
                        const existingGroup = acc.find(group => group.issueType.issue_type_id === item.issue_type_id);
                        if (existingGroup) {
                            if (item.user_code) {
                                existingGroup.user.push({
                                    name: item.user_display_name,
                                    user_code: item.user_code,
                                });
                            }
                        } else {
                            acc.push({
                                user: item.user_code ? [{
                                    name: item.user_display_name,
                                    user_code: item.user_code
                                }] : [],
                                issueType: {
                                    issue_type_name: item.issue_type_name,
                                    issue_type_id: item.issue_type_id,
                                }
                            });
                        }
                        return acc;
                    }, []);
                    setRows(groupedData);
                    setPreviousRows(JSON.parse(JSON.stringify(groupedData)));
                } else {
                    setRows([{ user: "", issueType: "" }]);
                    setPreviousRows(JSON.parse(JSON.stringify([{ user: "", issueType: "" }])));
                }
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {

        }
    }

    // handel row add in issue type add manage validation
    const addRow = useCallback(() => {
        if (rows?.length === 0) {
            setRows([...rows, { user: "", issueType: "" }]);
            return
        }
        const lastRow = rows[rows.length - 1];
        if (lastRow.user.length === 0 || !lastRow.issueType) {
            showInfo("info", "Please fill in both 'user' and 'issueType' fields before adding a new row.");
            return false;
        }
        const isDuplicate = rows.some((row, index) =>
            index < rows.length - 1 &&
            row.issueType?.issue_type_id === lastRow.issueType?.issue_type_id &&
            row.issueType?.product_code === lastRow.issueType?.product_code
        );
        if (isDuplicate) {
            setRows(rows.slice(0, -1));
            showInfo("error", "This issue type and product code already exist. Cannot add duplicate rows.");
            return
        }
        setRows([...rows, { user: "", issueType: "" }]);
        return true;
    }, [rows])

    const handleDropdownChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].issueType = value;
        setRows(updatedRows);
    };

    const handleMultiSelectChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].user = value;
        setRows(updatedRows);
    };

    // this function handle change
    const handleChange = (e) => {
        const { name, value } = e.target
        if (name === "user_start_date") {
            const result = new Date(value);
            const daysToAdd = projectData?.projectRole?.exp_days ? projectData?.projectRole?.exp_days : 30;
            result.setDate(result.getDate() + daysToAdd);
            setProjectData((prev) => ({ ...prev, [name]: value, user_end_date: result }))
        } if (name === "is_auto_build_allow" || name === "is_import_allow") {
            setProjectData((prev) => ({ ...prev, [name]: e?.target?.checked }))
        } else {
            setProjectData((prev) => ({ ...prev, [name]: value }))
        }
    }

    const handleEvent = (index) => {
        let updateData = [...rows]
        updateData[index].user = []
        setRows(updateData)
    }

    const findDuplicates = (rows) => {
        const seen = {};
        let duplicates = ""

        rows.forEach((row) => {
            const key = `${row.issueType.issue_type_id}-${row.issueType.product_code}`;
            if (seen[key]) {
                duplicates = row.issueType?.issue_type_name
            } else {
                seen[key] = true;
            }
        });
        return duplicates;
    };

    // this function handle upsert project Api calling
    const addOrEditProject = async () => {
        if (_.isEqual(projectData, previousData)) {
            showInfo("info", "No changes made");
            return;
        }
        if (!projectData.product_code) {
            showInfo("info", "Please select product.");
            return;
        } else if (!projectData?.project_name || projectData?.project_name?.project_name === "") {
            showInfo("info", "Please select project name.");
            return;
        }
        else if (!projectData?.project_key) {
            showInfo("info", "Please enter project key.");
            return;
        }
        else if (projectData?.client_id?.length === 0 && projectData?.product_code?.is_default) {
            showInfo("info", "Please select client.");
            return;
        }
        else if (!projectData?.project_type_id?.project_type_id && projectData?.product_code?.is_default) {
            showInfo("info", "Please select project type.");
            return;
        }

        try {
            const payload = {
                "project_id": projectData?.project_id,
                "project_key": projectData?.project_key || createAbbreviation(projectData?.project_name?.project_name),
                "project_name": projectData?.project_name?.project_name,
                "project_type_id": projectData?.project_type_id?.project_type_id,
                "product_code": projectData?.product_code?.product_code,
                "project_status_id": projectData?.project_status_id?.project_status_id,
                "project_start_date": DateTime.fromJSDate(new Date(projectData?.project_start_date)),
                "project_end_date": DateTime.fromJSDate(new Date(projectData?.project_end_date)) || "",
                "project_role_id": 0,
                "client_ids": _.pluck(projectData?.client_id, "client_id")?.toString(),
                "is_auto_build_allow": projectData?.is_auto_build_allow,
                "is_import_allow": projectData?.is_import_allow
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTPROJECTS"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("success", res?.body?.message)
                sessionStorage.removeItem("projects")
                setProjectData((prev) => ({ ...prev, project_id: res?.body?.data?.project_List[0]?.project_id, is_project_lead: res?.body?.data?.project_List[0]?.is_project_lead }))
                getProjectHighlights()
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }

    }

    // this function handle add or update issue tye with user
    const addIssueType = async () => {
        if (_.isEqual(previousRows, rows)) {
            showInfo("info", "No changes made");
            return;
        } else if (projectData?.project_id === 0 || projectData?.project_id === undefined) {
            showInfo("info", "Select project or save project.");
            return;
        } else if (findDuplicates(rows)) {
            showInfo("error", `This ${findDuplicates(rows)}  product code already exist. Cannot add duplicate rows.`);
            return
        }
        const issueType = _.filter(_.map(rows, item => {
            if (item.user && item.issueType) {
                return {
                    user_code: _.pluck(item.user, 'user_code').toString(),
                    issue_type_id: item.issueType.issue_type_id,
                    product_code: item.issueType.product_code
                };
            } else {
                return null;
            }

        }), Boolean)

        try {
            const payload = {
                "project_id": projectData?.project_id,
                "project_product_code": projectData?.product_code?.product_code,
                "issue_type_user_mapping": issueType
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTPROJECTUSERISSUES"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("success", res?.body?.message)
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    // this function handle  delete issue type with user
    const deleteIssueType = async (value, index) => {
        if (value?.issue_type_id === undefined || value?.issue_type_id === null) {
            showInfo("info", "Row can't delete.");
            return;
        }
        try {
            const payload = {
                "project_id": projectData?.project_id,
                "issue_type_id": value?.issue_type_id,
                "product_code": value?.product_code,
                "project_product_code": projectData?.product_code?.product_code,
            }
            const res = await services.getInvokeRemote("POST", Urls("PROJECTUSERISSUETYPEREMOVE"), payload);
            if (res?.body?.error_status === false) {
                rows.splice(index, 1)
                setRows([...rows])
                showSuccess("success", res?.body?.message)
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    // this function handle  delete single user with single role
    const deleteUser = async (value) => {
        try {
            const payload = {
                "project_id": projectData?.project_id,
                "product_code": projectData?.product_code?.product_code,
                "is_atlassian": projectData?.product_code?.product_type_key.includes("srkaycg_atlassian"),
                "project_user_roles": [
                    {
                        "project_user_code": value?.user_code,
                        "project_role_id": value?.project_role_id,
                        "atlassian_product_id": value?.product_accountId,
                        "is_billable": value?.is_billable,
                        "remark": ""
                    }
                ],

            }
            const res = await services.getInvokeRemote("POST", Urls("REMOVEPROJECTSUSERSROLES"), payload);
            if (res?.body?.error_status === false) {
                let user = _.filter(projectData.project_user_roles, (item) => item !== value);
                setProjectData((prev) => ({ ...prev, project_user_roles: user }))
                showSuccess("success", res?.body?.message)
                getProjectUserList(projectData?.project_id, projectData?.product_code?.product_code)
                getProjectDetails(projectData?.project_id, projectData?.product_code?.product_code)
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const userHandleChange = (e) => {
        const { name, value } = e.target
        if (name === "is_build_allow" || name === "is_server_build_allow" || name === "is_auto_build_request_permission") {
            setProjectData((prev) => ({ ...prev, [name]: e.target?.checked }))
        } else if (name === "user") {
            setProjectData((prev) => ({ ...prev, [name]: value, is_billable: getBillableStatus(value) }))
        } else if (name === "projectRole") {
            const result = new Date();
            const daysToAdd = value?.exp_days ? value?.exp_days : 30;
            result.setDate(result.getDate() + daysToAdd);
            setProjectData((prev) => ({ ...prev, [name]: value, user_start_date: new Date(), user_end_date: result }))
        } else {
            setProjectData((prev) => ({ ...prev, [name]: value }))
        }
    }

    const getBillableStatus = (selectedUsers) => {
        if (selectedUsers.every(u => u.is_billable === true)) return true;
        if (selectedUsers.every(u => u.is_billable === false)) return false;
        return false;
    };

    const handleRadioChange = (value, item, key) => {
        if (key === "list") {
            setConfirmation((prev) => ({ ...prev, list: true, user: item, is_billable: item?.is_billable, newvalue: value }))
            setMismatchedUsers([item]);
            setShowPopup(true);
        } else {
            const mismatched = projectData?.user?.filter(u => u.is_billable !== value?.target?.checked);
            if (mismatched?.length > 0) {
                setMismatchedUsers(mismatched);
                setShowPopup(true);
            }
            handleChange({ target: { name: "is_billable", value: value.target.checked } });
        }
    };

    const handleSelection = (key) => {
        if (!key) {
            const check = getBillableStatus(projectData?.user)
            if (check !== null) {
                setProjectData((prev) => ({
                    ...prev, user: projectData?.user, is_billable: check
                }));
            } else {
                const selected = projectData?.user.filter(users => !mismatchedUsers.some(user => user.user_code === users.user_code))
                setProjectData((prev) => ({
                    ...prev, user: selected, is_billable: getBillableStatus(selected)
                }));
                setConfirmation({})
                showInfo("Info", "These users have been deselected. You need to add them separately based on their billable status.");
            }
        }

    };



    // this function handle add or update project user with multiple role
    const addProjectUserRole = async (key, newValue, val) => {
        let result = [];
        let arr = [];
        if (key === "is_billable" || key === "is_build_allow" || key === "is_server_build_allow" || key === "expired_date" || key === "is_auto_build_request_permission" ||
            key === "communicators_category_ids" || key === "category_id"
        ) {
            arr = [{
                project_user_code: val?.user_code,
                project_role_id: val?.project_role_id,
                atlassian_product_id: val?.product_accountId,
                is_remove: false,
                is_billable: key === "is_billable" ? newValue : val?.is_billable,
                remark: confirmation?.remark || "",
                is_build_allow: key === "is_build_allow" ? val?.is_build_allow === undefined ? false : newValue : val?.is_build_allow,
                is_server_build_allow: key === "is_server_build_allow" ? val?.is_server_build_allow === undefined ? false : newValue : val?.is_server_build_allow,
                is_auto_build_request_permission: key === "is_auto_build_request_permission" ? val?.is_auto_build_request_permission === undefined ? false : newValue : val?.is_auto_build_request_permission,
                from_date: val?.alloted_date || "",
                to_date: key === "expired_date" ? DateTime.fromJSDate(new Date(newValue)) : val?.expired_date ? DateTime.fromJSDate(new Date(val?.expired_date)) : "" || "",
                component_id: 0,
                communicators_category_ids: key === "communicators_category_ids" ? newValue?.toString() : val?.communicators_category_ids?.toString() || "",
                category_id: key === "category_id" ? newValue : val?.category_id || 0
            }]
        } else {
            if (projectData?.project_id === 0 || projectData?.project_id === undefined) {
                showInfo("info", "Select project or save project.");
                return;
            } else if (projectData?.user?.length === 0) {
                showInfo("info", "Please select user.");
                return;
            } else if (!projectData?.projectRole) {
                showInfo("info", "Please select role.");
                return;
            }
            else if (!projectData?.user_start_date) {
                showInfo("info", "Please select allocate date.");
                return;
            }
            else if (!projectData?.user_end_date) {
                showInfo("info", "Please select expiry date.");
                return;
            }
            const users = projectData?.user?.map((val) => ({ ...val, ...[projectData?.projectRole] })) || [];
            users.flatMap(user => Object.keys(user)
                .filter(key => !isNaN(key))
                .map(key => {
                    if (_.isEmpty(_.findWhere(projectData?.project_user_roles, { project_role_id: user[key].project_role_id, user_code: user.user_code }))) {
                        result.push({
                            name: user.name,
                            user_code: user.user_code,
                            project_role_id: user[key].project_role_id,
                            project_role_name: user[key].project_role_name,
                            product_accountId: user.product_accountId,
                        })
                    }
                })
            );
        }

        try {
            const mismatched = _.pluck(mismatchedUsers, "user_code").toString()
            const payload = {
                "project_id": projectData?.project_id,
                "product_code": projectData?.product_code?.product_code,
                "product_project_id": projectData?.product_project_id,
                "project_key": projectData?.project_key,
                "is_atlassian": projectData?.product_code?.product_type_key.includes("srkaycg_atlassian"),
                "project_user_roles": (key === "is_billable" || key === "is_build_allow" || key === "is_server_build_allow" || key === "expired_date" || key === "is_auto_build_request_permission" || key === "communicators_category_ids" || key === "category_id") ? arr : _.map(result, item => ({
                    project_user_code: item.user_code,
                    project_role_id: item.project_role_id,
                    atlassian_product_id: item?.product_accountId,
                    is_remove: item?.is_remove,
                    is_billable: (projectData?.is_billable === undefined ? true : projectData?.is_billable),
                    is_build_allow: projectData?.is_build_allow === undefined ? false : projectData?.is_build_allow,
                    is_auto_build_request_permission: projectData?.is_auto_build_request_permission === undefined ? false : projectData?.is_auto_build_request_permission,
                    remark: (mismatched?.includes(item?.user_code) ? confirmation?.remark : "") || "",
                    is_server_build_allow: projectData?.is_server_build_allow === undefined ? false : projectData?.is_server_build_allow,
                    from_date: DateTime.fromJSDate(new Date(projectData?.user_start_date)),
                    to_date: DateTime.fromJSDate(new Date(projectData?.user_end_date)),
                    component_id: item?.component_id || 0,
                    communicators_category_ids: projectData?.communicators_category_ids?.toString(),
                    category_id: projectData?.category_id
                })),
            }
            const res = await services.getInvokeRemote("POST", Urls("ADDPROJECTSUSERSROLES"), payload);
            if (res?.body?.error_status === false) {
                if (key === "is_billable") {
                    projectData?.project_user_roles?.map((item) => {
                        if (item?.user_code === val?.user_code) {
                            item.is_billable = newValue;
                        }
                    })
                } else {
                    const usersAdded = _.uniq(_.pluck(result, "user_code"));
                    usersAdded?.map((item) => {
                        const data = _.filter(projectData?.project_user_roles, { user_code: item });
                        if (data) {
                            data?.map((user) => {
                                user["is_billable"] = projectData?.is_billable;
                            })
                        }
                    })
                    delete projectData?.is_billable;
                    delete projectData?.is_build_allow;
                    delete projectData?.is_server_build_allow;
                    delete projectData?.user_start_date;
                    delete projectData?.user_end_date;
                    delete projectData?.user;
                    delete projectData?.projectRole;
                    delete projectData?.is_auto_build_request_permission;
                    delete projectData?.communicators_category_ids
                    delete projectData?.category_id
                    setProjectData((prev) => ({ ...prev, project_user_roles: [...projectData?.project_user_roles, ...result] }));
                }
                if (key !== "is_billable" || key !== "is_build_allow" || key !== "is_server_build_allow") {
                    getProjectUserList(projectData?.project_id, projectData?.product_code?.product_code)
                }
                getProjectDetails(projectData?.project_id, projectData?.product_code?.product_code)
                showSuccess("success", res?.body?.message)
                setConfirmation({})
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            setConfirmation({})
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    // this function get the project user list
    const getProjectUserList = async (id, product_id) => {
        try {
            const payload = {
                "project_id": id ? id : projectData?.project_id,
                "product_code": product_id ? product_id : projectData?.product_code?.product_code,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTUSERLIST"), payload);
            if (res?.status === 200) {
                if (res?.body?.data) {
                    setOptions((prev) => ({ ...prev, projectUser: _.sortBy(res?.body?.data?.project_User_List, "user_display_name") }))
                }
            } else {
                setOptions((prev) => ({ ...prev, projectUser: [] }))
            }

        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    return useMemo(() => ({
        tagRef, checkPermission, option, rows, addRow, handleDropdownChange, handleMultiSelectChange, projectData, setProjectData, handleChange, addOrEditProject, deleteUser, deleteIssueType, editProject, setEditProject, getProjectDetails, handleEvent, addIssueType, addProjectUserRole, userHandleChange, handleRadioChange, confirmation, setConfirmation, showPopup, setShowPopup, handleSelection, mismatchedUsers, showInfo
    }), [tagRef, checkPermission, option, rows, addRow, handleDropdownChange, handleMultiSelectChange, projectData, setProjectData, handleChange, addOrEditProject, deleteUser, deleteIssueType, editProject, setEditProject, getProjectDetails, handleEvent, addIssueType, addProjectUserRole, userHandleChange, handleRadioChange, confirmation, setConfirmation, showPopup, setShowPopup, handleSelection, mismatchedUsers, showInfo])
}